// ENUMS FOR ROLES
const rolesTypes = {
    ADMINISTRATOR: 'administrator',
    FINANCIALADMINISTRATOR: 'financialAdministrator',
    MANAGER: 'manager',
    LABMANAGER: 'laboratoryManager',
    LABMICROBIOLOGIST: 'laboratoryMicrobiologist',
    LABCHEMIST: 'laboratoryChemist',
    SALESREP: 'salesRepresentative',
    SALESMANAGER: 'salesManager',
    LABTECH: 'laboratoryTechnician',
    SERVICETECH: 'serviceTechnician',
    OPERATOR: 'operator',
};

export default Object.freeze(rolesTypes);
